import PropTypes from "prop-types";

import PriceIndexInfo from "./price-index-info";
import PriceGraphic from "./price-graphic";

const DistrictReportPriceIndex = ({
  listingData,
  districtReportPriceInfos,
  listingTradeTypeValue,
  listingEstateType,
  isProjectPage,
  unitTypes,
  isPriceGraphicMarkerVisible = true,
}) => {
  const {
    averagePriceForSale,
    averagePriceForRent,
    amortization,
    exchangeRatio,
    exchangeState,
    graphicPrice,
    graphics,
    price,
  } = districtReportPriceInfos || {};

  const hasNoPriceInfo = [averagePriceForSale, averagePriceForRent, amortization, exchangeRatio, exchangeState].every(
    (value) => !value
  );

  const isVisiblePriceIndexInfoTabs = (!isProjectPage && hasNoPriceInfo) || false;
  const isVisiblePriceInfoGraphics =
    (graphicPrice || price) && graphics?.length > 0 && (averagePriceForSale || averagePriceForRent);

  return (
    <div>
      {!isVisiblePriceIndexInfoTabs && (
        <PriceIndexInfo
          averagePriceForSale={averagePriceForSale}
          averagePriceForRent={averagePriceForRent}
          amortization={amortization}
          exchangeRatio={exchangeRatio}
          exchangeState={exchangeState}
        />
      )}
      {isVisiblePriceInfoGraphics && (
        <PriceGraphic
          districtReportPriceInfos={districtReportPriceInfos}
          listingTradeTypeValue={listingTradeTypeValue}
          listingEstateTypeValue={listingEstateType}
          listingData={listingData}
          isProjectPage={isProjectPage}
          unitTypes={unitTypes}
          isPriceGraphicMarkerVisible={isPriceGraphicMarkerVisible}
        />
      )}
    </div>
  );
};

DistrictReportPriceIndex.propTypes = {
  listingData: PropTypes.object,
  districtReportDemographicInfos: PropTypes.object,
  districtReportPriceInfos: PropTypes.object,
  listingTradeTypeValue: PropTypes.string,
  listingEstateType: PropTypes.string,
  isProjectPage: PropTypes.bool,
  unitTypes: PropTypes.array,
  isPriceGraphicMarkerVisible: PropTypes.bool,
};
export default DistrictReportPriceIndex;
